/**
 *
 * Asynchronously loads the component for Manifest
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
